import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { requestPersistentStorage, registerServiceWorker } from './lib/service-worker';
import './styles.css';

/**
 * Заявките не се повтарят до безкрай и не се изхвърлят при загуба на връзка:
 * истинското хранилище е Dexie, а react-query само подрежда изтеглянето.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      gcTime: 24 * 60 * 60_000,
      networkMode: 'online',
    },
  },
});

registerServiceWorker();
void requestPersistentStorage();

const container = document.getElementById('root');
if (!container) throw new Error('Липсва контейнерът на приложението');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
